// src/components/PricingModal.js
import React, { useEffect } from 'react';
import './PricingModal.css';

export default function PricingModal({ isOpen, onClose, clientRefId, customerEmail }) {
  // Load the Stripe pricing-table script exactly once
  useEffect(() => {
    const scriptId = 'stripe-pricing-table-script';
    if (!document.getElementById(scriptId)) {
      const s = document.createElement('script');
      s.id = scriptId;
      s.src = 'https://js.stripe.com/v3/pricing-table.js';
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>✕</button>

        <stripe-pricing-table
          pricing-table-id="prctbl_1S6ES8CagDAeI1bFDt9xPpWO"
          publishable-key="pk_live_qjv7ksQqFLGV5T3oYoff4oQW"
          client-reference-id={clientRefId}
          customer-email={customerEmail}
        ></stripe-pricing-table>
      </div>
    </div>
  );
}
